import React, { Component } from 'react';
import { connect } from "react-redux";
import {
  Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button,
  Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, IconButton, DialogContentText, FormHelperText, Tooltip
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import OverLoader from "../../components/common/loader";
import { GetProjectsData, GetUsersData } from './LeadsAction';
import { GetBranches } from '../Branches/branchesAction';
import { GetThemes } from '../Themen/ThemesAction';
import { GetClassifications } from '../Classifications/ClassificationsAcction';
import { CreateLeadPlanOffer, UpdateLeadPlanOffer, DeleteLeadPlanOffer } from './LeadsAction';
import LeadPlans from '../../container/Leads/LeadPlans';
import LeadOffers from '../../container/Leads/LeadOffers';
import ExcelData from "./ExcelData";
import NumberFormat from "react-number-format";
import truncate from 'lodash/truncate';

class LeadsSearchResults extends Component {

  constructor(props) {
    super(props);
    this.state = {
      leadProjectNumber: '',
      leadCustomerName: '',
      leadProjectName: '',
      leadBranchNumber: '',
      leadThemeNumber: '',
      leadClassificationNumber: '',
      leadComment: '',
      leadPartnerNumberOne: '',
      leadPercentNumberOne: '',
      leadPartnerNumberTwo: '',
      leadPercentNumberTwo: '',
      leadPartnerNumberThree: '',
      leadPercentNumberThree: '',
      LeadPlanOfferCreateDialogOpen: false,
      lead_plans: [],
      lead_offers: [],
      updateMode: false,
      total_percentages: '',
      LeadPlanOfferDeleteDialogOpen: false,
      isLeadCustomerNameEmpty: false,
      isLeadProjectNameEmpty: false,
      isLeadBranchNumberEmpty: false,
      isLeadThemeNumberEmpty: false,
      isLeadClassificationNumberEmpty: false,
      isleadPartnerNumberOneEmpty: false,
      isleadPercentNumberOneEmpty: false,
      isleadPercentNumberOneRange: false,
      isleadPercentNumberTwoEmpty: false,
      isleadPercentNumberTwoRange: false,
      isleadPercentNumberThreeEmpty: false,
      isleadPercentNumberThreeRange: false,
      LeadPlanOfferPercentagesDialogOpen: false,
      LeadPlanOfferShouldCreateLeadPlanDialogOpen: false,
      isLeadPercentNumberTwoDisabled: true,
      isLeadPercentNumberThreeDisabled: true,
    }
  }

  componentDidMount() {
    const { GetProjectsData, GetUsersData, GetBranches, GetThemes, GetClassifications } = this.props;
    GetProjectsData();
    GetUsersData();
    GetBranches();
    GetThemes();
    GetClassifications();
  }

  componentDidUpdate(prevProps, prevState) {
    const { error_validation, lead_plan_offer } = this.props;
    if (prevProps.error_validation !== error_validation) {
      if (error_validation.lead["base"] && error_validation.lead["base"][0].length > 0) {
        this.setState({ must_contain_lead_plan: error_validation.lead["base"][0] })
      }
    }
    if (prevProps.lead_plan_offer !== lead_plan_offer) {
      this.setState({
        leadProjectNumber: '',
        leadCustomerName: '',
        leadProjectName: '',
        leadBranchNumber: '',
        leadThemeNumber: '',
        leadClassificationNumber: '',
        leadComment: '',
        leadPartnerNumberOne: '',
        leadPercentNumberOne: '',
        leadPartnerNumberTwo: '',
        leadPercentNumberTwo: '',
        leadPartnerNumberThree: '',
        leadPercentNumberThree: '',
        LeadPlanOfferCreateDialogOpen: false,
        lead_plans: [],
        lead_offers: [],
        total_percentages: false,
        isleadPercentNumberTwoEmpty: false,
        isleadPercentNumberTwoRange: false,
        isleadPercentNumberThreeEmpty: false,
        isleadPercentNumberThreeRange: false,
        LeadPlanOfferPercentagesDialogOpen: false
      })
    }
  }

  launchCreateLeadPlanOfferDialog = () => {
    this.setState({ LeadPlanOfferCreateDialogOpen: true, updateMode: false });
  }

  saveLeadPlanOfferDialog = () => {

    const { CreateLeadPlanOffer, year, branch_id, classification_id, theme_id, group_id } = this.props;

    const {
      leadProjectNumber,
      leadCustomerName,
      leadProjectName,
      leadBranchNumber,
      leadThemeNumber,
      leadClassificationNumber,
      leadComment,
      leadPartnerNumberOne,
      leadPercentNumberOne,
      leadPartnerNumberTwo,
      leadPercentNumberTwo,
      leadPartnerNumberThree,
      leadPercentNumberThree,
      lead_plans,
      lead_offers,
    } = this.state;

    if (leadCustomerName !== '' && leadProjectName !== '' && leadBranchNumber !== '' && leadThemeNumber !== '' && leadClassificationNumber !== '' && leadPartnerNumberOne !== '' &&
      (leadPercentNumberOne !== '' && leadPercentNumberOne > 0 && leadPercentNumberOne <= 100) &&
      (leadPartnerNumberTwo === '' || (leadPartnerNumberTwo !== '' && leadPercentNumberTwo !== '' && leadPercentNumberTwo > 0)) &&
      (leadPartnerNumberThree === '' || (leadPartnerNumberThree !== '' && leadPercentNumberThree !== '' && leadPercentNumberThree > 0))) {

      const total_sum = parseInt(leadPercentNumberOne) + parseInt(leadPercentNumberTwo || 0) + parseInt(leadPercentNumberThree || 0)

      if (total_sum !== 100) {
        this.setState({
          total_percentages: total_sum,
          LeadPlanOfferPercentagesDialogOpen: true
        })
      } else {
        CreateLeadPlanOffer(leadProjectNumber, leadCustomerName, leadProjectName, leadBranchNumber, leadThemeNumber, leadClassificationNumber,
          leadComment, leadPartnerNumberOne, leadPercentNumberOne, leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
          leadPercentNumberThree, lead_plans, lead_offers, year, branch_id, classification_id, theme_id, group_id);
      }
    } else {
      if (leadCustomerName === '')
        this.setState({ isLeadCustomerNameEmpty: true })
      else if (leadProjectName === '')
        this.setState({ isLeadProjectNameEmpty: true })
      else if (leadBranchNumber === '')
        this.setState({ isLeadBranchNumberEmpty: true })
      else if (leadThemeNumber === '')
        this.setState({ isLeadThemeNumberEmpty: true })
      else if (leadClassificationNumber === '')
        this.setState({ isLeadClassificationNumberEmpty: true })
      else if (leadPartnerNumberOne === '')
        this.setState({ isleadPartnerNumberOneEmpty: true })
      else if (leadPercentNumberOne === '')
        this.setState({ isleadPercentNumberOneEmpty: true, isleadPercentNumberOneRange: false })
      else if (parseInt(leadPercentNumberOne) === 0 || leadPercentNumberOne > 100)
        this.setState({ isleadPercentNumberOneRange: true, isleadPercentNumberOneEmpty: false })
      else if (leadPartnerNumberTwo !== '' && leadPercentNumberTwo === '')
        this.setState({ isleadPercentNumberTwoEmpty: true, isleadPercentNumberTwoRange: false })
      else if (leadPartnerNumberTwo !== '' && parseInt(leadPercentNumberTwo) === 0)
        this.setState({ isleadPercentNumberTwoRange: true, isleadPercentNumberTwoEmpty: false })
      else if (leadPartnerNumberThree !== '' && leadPercentNumberThree === '')
        this.setState({ isleadPercentNumberThreeEmpty: true, isleadPercentNumberThreeRange: false })
      else if (leadPartnerNumberThree !== '' && parseInt(leadPercentNumberThree) === 0)
        this.setState({ isleadPercentNumberThreeRange: true, isleadPercentNumberThreeEmpty: false })
    }
  }

  updateLeadPlanOfferDialog = () => {

    const { UpdateLeadPlanOffer, year, branch_id, classification_id, theme_id, group_id } = this.props;

    const {
      lead_id, leadProjectNumber, leadCustomerName, leadProjectName, leadBranchNumber, leadThemeNumber, leadClassificationNumber, leadComment,
      leadPartnerNumberOne, leadPercentNumberOne, leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree, leadPercentNumberThree,
    } = this.state;

    if (leadCustomerName !== '' && leadProjectName !== '' && leadBranchNumber !== '' && leadThemeNumber !== '' && leadClassificationNumber !== '' && leadPartnerNumberOne !== '' &&
      (leadPercentNumberOne !== '' && leadPercentNumberOne > 0 && leadPercentNumberOne <= 100) &&
      ((leadPartnerNumberTwo === '' || leadPartnerNumberTwo === '-1') || (leadPercentNumberTwo !== '' && leadPercentNumberTwo > 0)) &&
      ((leadPartnerNumberThree === '' || leadPartnerNumberThree === '-1') || (leadPercentNumberThree !== '' && leadPercentNumberThree > 0))) {

      UpdateLeadPlanOffer(lead_id, leadProjectNumber, leadCustomerName, leadProjectName, leadBranchNumber, leadThemeNumber, leadClassificationNumber,
        leadComment, leadPartnerNumberOne, leadPercentNumberOne, leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
        leadPercentNumberThree, year, branch_id, classification_id, theme_id, group_id);

    } else {
      if (leadCustomerName === '')
        this.setState({ isLeadCustomerNameEmpty: true })
      else if (leadProjectName === '')
        this.setState({ isLeadProjectNameEmpty: true })
      else if (leadBranchNumber === '')
        this.setState({ isLeadBranchNumberEmpty: true })
      else if (leadThemeNumber === '')
        this.setState({ isLeadThemeNumberEmpty: true })
      else if (leadClassificationNumber === '')
        this.setState({ isLeadClassificationNumberEmpty: true })
      else if (leadPartnerNumberOne === '')
        this.setState({ isleadPartnerNumberOneEmpty: true })
      else if (leadPercentNumberOne === '')
        this.setState({ isleadPercentNumberOneEmpty: true, isleadPercentNumberOneRange: false })
      else if (parseInt(leadPercentNumberOne) === 0 || leadPercentNumberOne > 100)
        this.setState({ isleadPercentNumberOneRange: true, isleadPercentNumberOneEmpty: false })
      else if (leadPartnerNumberTwo !== '' && leadPercentNumberTwo === '')
        this.setState({ isleadPercentNumberTwoEmpty: true, isleadPercentNumberTwoRange: false })
      else if (leadPartnerNumberTwo !== '' && parseInt(leadPercentNumberTwo) === 0)
        this.setState({ isleadPercentNumberTwoRange: true, isleadPercentNumberTwoEmpty: false })
      else if (leadPartnerNumberThree !== '' && leadPercentNumberThree === '')
        this.setState({ isleadPercentNumberThreeEmpty: true, isleadPercentNumberThreeRange: false })
      else if (leadPartnerNumberThree !== '' && parseInt(leadPercentNumberThree) === 0)
        this.setState({ isleadPercentNumberThreeRange: true, isleadPercentNumberThreeEmpty: false })
    }
  }

  addLeadPlanOfferDialog = () => {
    const { updateMode } = this.state;
    if (updateMode) {
      this.updateLeadPlanOfferDialog();
    } else {
      this.saveLeadPlanOfferDialog();
    }
  }

  abortLeadPlanOfferDialog = () => {
    this.setState({
      LeadPlanOfferCreateDialogOpen: false,
      leadProjectNumber: '',
      leadCustomerName: '',
      leadProjectName: '',
      leadBranchNumber: '',
      leadThemeNumber: '',
      leadClassificationNumber: '',
      leadComment: '',
      leadPartnerNumberOne: '',
      leadPercentNumberOne: '',
      leadPartnerNumberTwo: '',
      leadPercentNumberTwo: '',
      leadPartnerNumberThree: '',
      leadPercentNumberThree: '',
      lead_plans: [],
      lead_offers: [],
      total_percentages: '',
      isLeadCustomerNameEmpty: '',
      isLeadProjectNameEmpty: '',
      isLeadBranchNumberEmpty: '',
      isLeadThemeNumberEmpty: '',
      isLeadClassificationNumberEmpty: '',
      isleadPartnerNumberOneEmpty: '',
      isleadPercentNumberOneEmpty: '',
      isleadPercentNumberOneRange: '',
      isleadPercentNumberTwoEmpty: '',
      isleadPercentNumberThreeEmpty: '',
      isleadPercentNumberTwoRange: '',
      isleadPercentNumberThreeRange: '',
      LeadPlanOfferPercentagesDialogOpen: false,
    });
  }

  launchEditLeadPlanOfferDialog = (lead) => {
    if (lead.lead2percent !== null && lead.lead2percent !== 0) {
      this.setState({ isLeadPercentNumberTwoDisabled: false })
    }
    if (lead.lead3percent !== null && lead.lead3percent !== 0) {
      this.setState({ isLeadPercentNumberThreeDisabled: false })
    }
    this.setState({
      LeadPlanOfferCreateDialogOpen: true,
      lead_id: lead.id,
      leadProjectNumber: lead.project_id,
      leadCustomerName: lead.customername,
      leadProjectName: lead.projectname,
      leadBranchNumber: lead.branch_id,
      leadThemeNumber: lead.theme_id,
      leadClassificationNumber: lead.classification_id,
      leadComment: lead.comment,
      leadPartnerNumberOne: lead.lead1id,
      leadPercentNumberOne: lead.lead1percent,
      leadPartnerNumberTwo: lead.lead2id === 0 || lead.lead2id === null ? '' : lead.lead2id,
      leadPercentNumberTwo: lead.lead2percent === 0 || lead.lead2percent === null || lead.lead2percent === '' ? '' : lead.lead2percent,
      leadPartnerNumberThree: lead.lead3id === 0 || lead.lead3id === null ? '' : lead.lead3id,
      leadPercentNumberThree: lead.lead3percent === 0 || lead.lead3percent === null || lead.lead3percent === '' ? '' : lead.lead3percent,
      lead_plans: lead.lead_plans,
      lead_offers: lead.offers,
      updateMode: true
    });
  }

  handlePlansClick = (planData) => {
    this.setState(state => ({
      lead_plans: [...state.lead_plans, planData]
    }));
  }

  handleOffersClick = (offerData) => {
    this.setState(state => ({
      lead_offers: [...state.lead_offers, offerData]
    }));
  }

  launchDeleteLeadDialog = () => {
    this.setState({ LeadPlanOfferDeleteDialogOpen: true });
  }

  handleRemoveRow = () => {
    const { lead_id } = this.state;
    const { year, branch_id, classification_id, theme_id, group_id } = this.props;
    this.props.DeleteLeadPlanOffer(lead_id, year, branch_id, classification_id, theme_id, group_id);
    this.setState({ LeadPlanOfferDeleteDialogOpen: false, LeadPlanOfferCreateDialogOpen: false });
  };

  closeDeleteLeadPlanOfferDialog = () => {
    this.setState({ LeadPlanOfferDeleteDialogOpen: false })
  }

  handleLeadProjectNumberSelect = (e) => {
    this.setState({ leadProjectNumber: e.target.value })
  }

  handleLeadBranchNumberSelect = (e) => {
    this.setState({ leadBranchNumber: e.target.value, isLeadBranchNumberEmpty: false })
  }

  handleLeadThemeNumberSelect = (e) => {
    this.setState({ leadThemeNumber: e.target.value, isLeadThemeNumberEmpty: false })
  }

  handleLeadClassificationNumberSelect = (e) => {
    this.setState({ leadClassificationNumber: e.target.value, isLeadClassificationNumberEmpty: false })
  }

  handleLeadPartnerNumberOneSelect = (e) => {
    this.setState({ leadPartnerNumberOne: e.target.value, isleadPartnerNumberOneEmpty: false })
  }

  handleLeadPartnerNumberTwoSelect = (e) => {
    if (e.target.value === '-1') {
      this.setState({ leadPercentNumberTwo: '', isLeadPercentNumberTwoDisabled: true })
    } else {
      this.setState({ isLeadPercentNumberTwoDisabled: false })
    }
    this.setState({ leadPartnerNumberTwo: e.target.value })
  }

  handleLeadPartnerNumberThreeSelect = (e) => {
    if (e.target.value === '-1') {
      this.setState({ leadPercentNumberThree: '', isLeadPercentNumberThreeDisabled: true })
    } else {
      this.setState({ isLeadPercentNumberThreeDisabled: false })
    }
    this.setState({ leadPartnerNumberThree: e.target.value })
  }

  saveLeadPlanOfferPercentagesDialog = () => {
    if (this.state.lead_plans.length > 0) {
      const { CreateLeadPlanOffer, year, branch_id, classification_id, theme_id, group_id } = this.props;

      const {
        leadProjectNumber,
        leadCustomerName,
        leadProjectName,
        leadBranchNumber,
        leadThemeNumber,
        leadClassificationNumber,
        leadComment,
        leadPartnerNumberOne,
        leadPercentNumberOne,
        leadPartnerNumberTwo,
        leadPercentNumberTwo,
        leadPartnerNumberThree,
        leadPercentNumberThree,
        lead_plans,
        lead_offers,
      } = this.state;

      CreateLeadPlanOffer(leadProjectNumber, leadCustomerName, leadProjectName, leadBranchNumber, leadThemeNumber, leadClassificationNumber,
        leadComment, leadPartnerNumberOne, leadPercentNumberOne, leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
        leadPercentNumberThree, lead_plans, lead_offers, year, branch_id, classification_id, theme_id, group_id);
    } else {
      this.setState({
        LeadPlanOfferShouldCreateLeadPlanDialogOpen: true,
        LeadPlanOfferPercentagesDialogOpen: false
      })
    }
  }

  closeLeadPlanOfferPercentagesDialog = () => {
    this.setState({ LeadPlanOfferPercentagesDialogOpen: false })
  }

  closeLeadPlanOfferShouldCreateLeadPlanDialog = () => {
    this.setState({
      LeadPlanOfferShouldCreateLeadPlanDialogOpen: false
    })
  }

  createExcel = () => {
    this.setState({ createExcel: true }, () => {
      setTimeout(() => {
        this.setState({ createExcel: false })
      }, 3000)
    })
  }

  getFormattedNumber(value) {
    return <NumberFormat
      value={value}
      displayType={'text'}
      thousandSeparator='.'
      decimalSeparator=','
      decimalScale={0}
      fixedDecimalScale={true}
      isNumericString={true}
    />
  }

  render() {

    const { isloading, year, leads_list, projects_list, users_list, branches_list, themes_list, classifications_list } = this.props;
    const access_rights = JSON.parse(localStorage.getItem('access_right'));

    const {
      LeadPlanOfferCreateDialogOpen,
      leadProjectNumber,
      leadCustomerName,
      leadProjectName,
      leadBranchNumber,
      leadThemeNumber,
      leadClassificationNumber,
      leadComment,
      leadPartnerNumberOne,
      leadPercentNumberOne,
      leadPartnerNumberTwo,
      leadPercentNumberTwo,
      leadPartnerNumberThree,
      leadPercentNumberThree,
      lead_plans,
      lead_offers,
      lead_id,
      updateMode,
      total_percentages,
      LeadPlanOfferDeleteDialogOpen,
      isLeadCustomerNameEmpty,
      isLeadProjectNameEmpty,
      isLeadBranchNumberEmpty,
      isLeadThemeNumberEmpty,
      isLeadClassificationNumberEmpty,
      isleadPartnerNumberOneEmpty,
      isleadPercentNumberOneEmpty,
      isleadPercentNumberOneRange,
      isleadPercentNumberTwoEmpty,
      isleadPercentNumberTwoRange,
      isleadPercentNumberThreeEmpty,
      isleadPercentNumberThreeRange,
      LeadPlanOfferPercentagesDialogOpen,
      LeadPlanOfferShouldCreateLeadPlanDialogOpen,
      isLeadPercentNumberTwoDisabled,
      isLeadPercentNumberThreeDisabled,
      createExcel
    } = this.state;

    if (leads_list.length === 0) return null;

    const total_plan_one = parseInt(leads_list.summary.nk) + parseInt(leads_list.summary.honorar);
    const total_plan_two = parseInt(total_plan_one) + parseInt(leads_list.summary.leadplan_plan2);
    const total_plan_three = parseInt(total_plan_one) + parseInt(leads_list.summary.leadplan_plan3);

    return (
      <React.Fragment>
        {isloading && <OverLoader />}
        <Grid container item xs={12} spacing={1} style={{ marginTop: '10px' }}
          className="SearchResultsTableBorders">
          {Number(access_rights.leads) === 2 ?
            <Button variant="outlined" className="m-10" color="primary" onClick={this.launchCreateLeadPlanOfferDialog}>Neue Akquise</Button>
            : ''}
          <Button variant="outlined" className="m-10" color="primary" onClick={this.createExcel}>Export Excel</Button>
          <TableContainer component={Paper} className="leads-table">
            <Table size="small" aria-label="dense table" id="lead_listing">
              <TableHead className={'leads_listing_head'}>
                <TableRow>
                  <TableCell align="left" colSpan={2}></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="center" colSpan={3}>Jahresplanung {year}</TableCell>
                  <TableCell align="center" colSpan={2}>Real/Ist {year}</TableCell>
                  <TableCell align="center" colSpan={2}>Lead 1</TableCell>
                  <TableCell align="center" colSpan={2}>Lead 2</TableCell>
                  <TableCell align="center" colSpan={2}>Lead 3</TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" colSpan={2}></TableCell>
                  <TableCell align="left" width="3%">Proj.Nr.</TableCell>
                  <TableCell align="left" width="8%">Kunde</TableCell>
                  <TableCell align="left" width="8%">Projektname</TableCell>
                  <TableCell align="left" width="8%">Branche</TableCell>
                  <TableCell align="left" width="8%">Thema</TableCell>
                  <TableCell align="left" width="8%">Einstufung</TableCell>
                  <TableCell align="right" width="2%">%</TableCell>
                  <TableCell align="left" width="5%">Plan II</TableCell>
                  <TableCell align="left" width="5%">Plan III</TableCell>
                  <TableCell align="left" width="3%">NK</TableCell>
                  <TableCell align="left" width="5%">Honorar</TableCell>
                  <TableCell align="left" width="3%">Name</TableCell>
                  <TableCell align="right" width="2%">%</TableCell>
                  <TableCell align="left" width="3%">Name</TableCell>
                  <TableCell align="right" width="2%">%</TableCell>
                  <TableCell align="left" width="3%">Name</TableCell>
                  <TableCell align="right" width="2%">%</TableCell>
                  <TableCell align="left" width="10%">Kommentar</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  Object.keys(leads_list.leads).map((key, index) => {
                    return leads_list.leads[key].map((h, index) => {
                      if (index < leads_list.leads[key].length - 1) {
                        return (<TableRow key={`mi-${index}`} className={index % 2 == 0 ? '' : 'leads_listing_middle_rows'}>
                          <TableCell align="right" colSpan={2}>
                            <IconButton
                              onClick={() => this.launchEditLeadPlanOfferDialog(h)}>
                              <EditIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell align="left">{h.projectno}</TableCell>
                          <TableCell align="left">
                            <Tooltip title={h.customername}>
                              <span align="left">{truncate(h.customername, { 'length': 22, 'separator': ' ' })}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left">
                            <Tooltip title={h.projectname}>
                              <span align="left">{truncate(h.projectname, { 'length': 22, 'separator': ' ' })}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left">
                            <Tooltip title={h.branch}>
                              <span align="left">{truncate(h.branch, { 'length': 15, 'separator': ' ' })}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left">
                            <Tooltip title={h.theme}>
                              <span align="left">{truncate(h.theme, { 'length': 15, 'separator': ' ' })}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="left">
                            <Tooltip title={h.classification}>
                              <span align="left">{truncate(h.classification, { 'length': 20, 'separator': ' ' })}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="right">{this.getFormattedNumber(h.leadplan_probability)}</TableCell>
                          <TableCell align="right">{this.getFormattedNumber(h.leadplan_plan2)}</TableCell>
                          <TableCell align="right" style={{ backgroundColor: '#C5FFC1' }}>{this.getFormattedNumber(h.leadplan_plan3)}</TableCell>
                          <TableCell align="right">{h.nk === 0 ? '' : this.getFormattedNumber(h.nk)}</TableCell>
                          <TableCell align="right" style={{ backgroundColor: '#FFFF87' }}>{h.honorar === 0 ? '' : this.getFormattedNumber(h.honorar)}</TableCell>
                          <TableCell align="left">{h.lead1name}</TableCell>
                          <TableCell align="right">{h.lead1percent === 0 ? '' : this.getFormattedNumber(h.lead1percent)}</TableCell>
                          <TableCell align="left">{h.lead2name}</TableCell>
                          <TableCell align="right">{h.lead2percent === 0 ? '' : this.getFormattedNumber(h.lead2percent)}</TableCell>
                          <TableCell align="left">{h.lead3name}</TableCell>
                          <TableCell align="right">{h.lead3percent === 0 ? '' : this.getFormattedNumber(h.lead3percent)}</TableCell>
                          <TableCell align="left">
                            <Tooltip title={h.comment}>
                              <span align="left">{truncate(h.comment, { 'length': 35, 'separator': ' ' })}</span>
                            </Tooltip>
                          </TableCell>
                        </TableRow>)
                      } else {
                        return (<TableRow key={`mi-${index}`} className={'leads_listing_sum_row'}>
                          <TableCell align="right" colSpan={2} style={{ backgroundColor: '#274E80' }}></TableCell>
                          <TableCell align="left" colSpan={6}>{key}</TableCell>
                          <TableCell align="right">{this.getFormattedNumber(h.leadplan_probability)}</TableCell>
                          <TableCell align="right">{this.getFormattedNumber(h.leadplan_plan2)}</TableCell>
                          <TableCell align="right" style={{ backgroundColor: '#C5FFC1' }}>{this.getFormattedNumber(h.leadplan_plan3)}</TableCell>
                          <TableCell align="right">{h.nk === 0 ? '' : this.getFormattedNumber(h.nk)}</TableCell>
                          <TableCell align="right" style={{ backgroundColor: '#FFFF87' }}>{h.honorar === 0 ? '' : this.getFormattedNumber(h.honorar)}</TableCell>
                          <TableCell align="right"></TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                        </TableRow>)
                      }
                    })
                  })
                }
                <TableRow>
                  <TableCell align="right" colSpan={2}></TableCell>
                  <TableCell align="left" colSpan={6}>Summe</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right">{this.getFormattedNumber(leads_list.summary.leadplan_plan2)}</TableCell>
                  <TableCell align="right">{this.getFormattedNumber(leads_list.summary.leadplan_plan3)}</TableCell>
                  <TableCell align="right">{this.getFormattedNumber(leads_list.summary.nk)}</TableCell>
                  <TableCell align="right">{this.getFormattedNumber(leads_list.summary.honorar)}</TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <TableContainer component={Paper} className="leads-table" style={{width: '25%', margin: '0 auto'}}>
          <Table size="small" aria-label="dense table" id="lead_listing">
            <TableHead className={'leads_listing_head'}>
              <TableRow>
                <TableCell align="left" style={{ backgroundColor: '#FFFF87', fontWeight: 'bold' }}>Plan 1</TableCell>
                <TableCell align="left" style={{ backgroundColor: '#7385B0', fontWeight: 'bold' }}>Plan 2</TableCell>
                <TableCell align="left" style={{ backgroundColor: '#C5FFC1', fontWeight: 'bold' }}>Plan 3</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="right" style={{ backgroundColor: '#FFFF87', fontWeight: 'bold' }}>{this.getFormattedNumber(total_plan_one)}</TableCell>
                <TableCell align="right" style={{ backgroundColor: '#7385B0', fontWeight: 'bold' }}>{this.getFormattedNumber(total_plan_two)}</TableCell>
                <TableCell align="right" style={{ backgroundColor: '#C5FFC1', fontWeight: 'bold' }}>{this.getFormattedNumber(total_plan_three)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog className="leads-modal" open={LeadPlanOfferCreateDialogOpen} fullWidth={true} maxWidth={"lg"}>
          <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>Akquise bearbeiten</DialogTitle>
          <DialogContent className="p-60">
            <Grid container spacing={1} justify="center" className="SearchResultsTableBorders">
              <Grid item xs={8} className={`${(Number(access_rights.leads) === 2) ? '' : 'disableALlFields'}`}>
                <Grid container spacing={1}>
                  <Grid item xs={2} style={{ lineHeight: '3' }}>
                    Projekt-Nr.
                                    </Grid>
                  <Grid item xs={10}>
                    <TextField
                      value={leadProjectNumber}
                      select
                      variant="outlined"
                      className="select-box"
                      size="small"
                      fullWidth
                      onChange={(e) => this.handleLeadProjectNumberSelect(e)}>
                      {projects_list && [{ id: '-1', projectno: "<Projekt", projectname: "auswählen>" }, ...projects_list].map(project_list => (
                        <MenuItem key={project_list.id} value={project_list.id}>{project_list.id === '-1' ? project_list.projectno + " " + project_list.projectname : project_list.projectno + " | " + project_list.projectname}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={2} style={{ lineHeight: '3' }}>
                    Kunde
                                    </Grid>
                  <Grid item xs={10}>
                    <TextField inputProps={{ maxLength: 50 }} required fullWidth size="small"
                      value={leadCustomerName}
                      onChange={(e) => this.setState({
                        leadCustomerName: e.target.value,
                        isLeadCustomerNameEmpty: false
                      })}
                      helperText={isLeadCustomerNameEmpty ? 'Bitte geben Sie den Kundennamen ein' : ''}
                      error={isLeadCustomerNameEmpty ? true : false}
                      variant="outlined" />
                  </Grid>

                  <Grid item xs={2} style={{ lineHeight: '3' }}>
                    Projektname
                                    </Grid>
                  <Grid item xs={10}>
                    <TextField inputProps={{ maxLength: 50 }} required fullWidth size="small"
                      value={leadProjectName}
                      onChange={(e) => this.setState({
                        leadProjectName: e.target.value,
                        isLeadProjectNameEmpty: false
                      })}
                      helperText={isLeadProjectNameEmpty ? 'Bitte geben Sie den Projektnamen ein' : ''}
                      error={isLeadProjectNameEmpty ? true : false}
                      variant="outlined" />
                  </Grid>

                  <Grid item xs={2} style={{ lineHeight: '3' }}>
                    Branche
                                    </Grid>
                  <Grid item xs={10}>
                    <TextField
                      helperText={isLeadBranchNumberEmpty ? 'Bitte wählen Sie eine Branche aus' : ''}
                      error={isLeadBranchNumberEmpty ? true : false}
                      value={leadBranchNumber}
                      select
                      variant="outlined"
                      className="select-box"
                      size="small"
                      fullWidth
                      onChange={(e) => this.handleLeadBranchNumberSelect(e)}
                    >
                      {branches_list && branches_list.map(branch_list => (
                        <MenuItem key={branch_list.id}
                          value={branch_list.id}>{branch_list.name}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={2} style={{ lineHeight: '3' }}>
                    Thema
                                    </Grid>
                  <Grid item xs={10}>
                    <TextField
                      helperText={isLeadThemeNumberEmpty ? 'Bitte wählen Sie ein Thema aus' : ''}
                      error={isLeadThemeNumberEmpty ? true : false}
                      value={leadThemeNumber}
                      select
                      variant="outlined"
                      className="select-box"
                      size="small"
                      fullWidth
                      onChange={(e) => this.handleLeadThemeNumberSelect(e)}
                    >
                      {themes_list && themes_list.map(theme_list => (
                        <MenuItem key={theme_list.id}
                          value={theme_list.id}>{theme_list.name}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={2} style={{ lineHeight: '3' }}>
                    Einstufung
                                    </Grid>
                  <Grid item xs={10}>
                    <TextField
                      helperText={isLeadClassificationNumberEmpty ? 'Bitte wählen Sie eine Einstufung aus' : ''}
                      error={isLeadClassificationNumberEmpty ? true : false}
                      value={leadClassificationNumber}
                      select
                      variant="outlined"
                      className="select-box"
                      size="small"
                      fullWidth
                      onChange={(e) => this.handleLeadClassificationNumberSelect(e)}
                    >
                      {classifications_list && classifications_list.map(classification_list => (
                        <MenuItem key={classification_list.id}
                          value={classification_list.id}>{classification_list.name}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={2} style={{ lineHeight: '3' }}>
                    Lead Partner
                                    </Grid>
                  <Grid item xs={10} style={{ lineHeight: '3' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={4} style={{ maxWidth: '27%' }}>
                        <div className="partner-div">
                          <TextField
                            value={leadPartnerNumberOne}
                            select
                            variant="outlined"
                            className="select-box"
                            size="small"
                            onChange={(e) => this.handleLeadPartnerNumberOneSelect(e)}
                          >
                            {users_list && users_list.map(user_list => (
                              <MenuItem key={user_list.id} value={user_list.id}>{user_list.loginname}</MenuItem>
                            ))}
                          </TextField>
                          <TextField required={true} fullWidth inputProps={{ maxLength: 3 }}
                            size="small"
                            variant="outlined"
                            style={{ padding: '1px', margin: '1px' }}
                            value={leadPercentNumberOne === '' ? '' : leadPercentNumberOne}
                            onChange={(e) => this.setState({
                              leadPercentNumberOne: e.target.value.replace(/\D/, ''),
                              isleadPercentNumberOneEmpty: false,
                              isleadPercentNumberOneRange: false
                            })}
                          />
                          <span>%</span>
                        </div>
                      </Grid>
                      <Grid item xs={1} style={{ lineHeight: '3', textAlign: 'center' }}>
                        Lead 2
                                            </Grid>
                      <Grid item xs={4} style={{ maxWidth: '27%' }}>
                        <div className="partner-div">
                          <TextField
                            value={leadPartnerNumberTwo}
                            select
                            variant="outlined"
                            className="select-box"
                            size="small"
                            onChange={(e) => this.handleLeadPartnerNumberTwoSelect(e)}
                          >
                            {users_list && [{ id: '-1', loginname: "<Berater wählen>" }, ...users_list].map(user_list => (
                              <MenuItem key={user_list.id} value={user_list.id}>{user_list.loginname}</MenuItem>
                            ))}
                          </TextField>
                          <TextField required={true} fullWidth inputProps={{ maxLength: 3 }}
                            size="small"
                            variant="outlined"
                            style={{ padding: '1px', margin: '1px' }}
                            disabled={isLeadPercentNumberTwoDisabled ? true : ''}
                            value={leadPercentNumberTwo === '' ? '' : leadPercentNumberTwo}
                            onChange={(e) => this.setState({
                              leadPercentNumberTwo: e.target.value.replace(/\D/, ''),
                              isleadPercentNumberTwoEmpty: false,
                              isleadPercentNumberTwoRange: false,
                            })}
                          />
                          <span>%</span>
                        </div>
                      </Grid>
                      <Grid item xs={1} style={{ lineHeight: '3', textAlign: 'center' }}>
                        Lead 3
                                            </Grid>
                      <Grid item xs={4} style={{ maxWidth: '27%' }}>
                        <div className="partner-div">
                          <TextField
                            value={leadPartnerNumberThree}
                            select
                            variant="outlined"
                            className="select-box"
                            size="small"
                            onChange={(e) => this.handleLeadPartnerNumberThreeSelect(e)}
                          >
                            {users_list && [{ id: '-1', loginname: "<Berater wählen>" }, ...users_list].map(user_list => (
                              <MenuItem key={user_list.id} value={user_list.id}>{user_list.loginname}</MenuItem>
                            ))}
                          </TextField>
                          <TextField required={true} fullWidth inputProps={{ maxLength: 3 }}
                            size="small"
                            variant="outlined"
                            style={{ padding: '1px', margin: '1px' }}
                            disabled={isLeadPercentNumberThreeDisabled ? true : ''}
                            value={leadPercentNumberThree === '' ? '' : leadPercentNumberThree}
                            onChange={(e) => this.setState({
                              leadPercentNumberThree: e.target.value.replace(/\D/, ''),
                              isleadPercentNumberThreeEmpty: false,
                              isleadPercentNumberThreeRange: false
                            })}
                          />
                          <span>%</span>
                        </div>
                      </Grid>
                      <FormHelperText error>{isleadPartnerNumberOneEmpty && isleadPartnerNumberOneEmpty ? 'Lead Partner darf nicht leer sein' : ''}</FormHelperText>
                      <FormHelperText error>{isleadPercentNumberOneEmpty && isleadPercentNumberOneEmpty ? 'Lead Partner % darf nicht leer sein' : ''}</FormHelperText>
                      <FormHelperText error>{isleadPercentNumberOneRange && isleadPercentNumberOneRange ? 'Lead Partner % darf nicht größer als 100 oder kleiner als 0 sein' : ''}</FormHelperText>
                      <FormHelperText error>{isleadPercentNumberTwoEmpty && isleadPercentNumberTwoEmpty ? 'Hauptpartner Zwei Prozent sollten nicht leer sein' : ''}</FormHelperText>
                      <FormHelperText error>{isleadPercentNumberTwoRange && isleadPercentNumberTwoRange ? 'Lead Partner Zwei Prozent sollten nicht größer als 100 und kleiner als 0 sein' : ''}</FormHelperText>
                      <FormHelperText error>{isleadPercentNumberThreeEmpty && isleadPercentNumberThreeEmpty ? 'Hauptpartner Drei Prozent sollten nicht leer sein' : ''}</FormHelperText>
                      <FormHelperText error>{isleadPercentNumberThreeRange && isleadPercentNumberThreeRange ? 'Hauptpartner Drei Prozent sollten nicht größer als 100 und kleiner als 0 sein' : ''}</FormHelperText>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} className={`${(Number(access_rights.leads) === 2) ? '' : 'disableALlFields'}`}>
                <Grid container spacing={1}>
                  <Grid item xs={3} style={{ lineHeight: '1.5' }}>
                    Kommentar
                                    </Grid>
                  <Grid item xs={9}>
                    <TextField required fullWidth multiline rows={7} rowsMax={Infinity}
                      variant="outlined" value={leadComment}
                      onChange={(e) => this.setState({ leadComment: e.target.value })} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1} justify="center" className="SearchResultsTableBorders">
              <Grid item xs={10}>
                <Grid container spacing={1}>
                  <LeadPlans plansClick={this.handlePlansClick} existing_lead_plans={lead_plans}
                    must_contain_lead_plan={this.state.must_contain_lead_plan}
                    lead_id={lead_id} updateMode={updateMode} />
                  <LeadOffers offersClick={this.handleOffersClick} existing_lead_offers={lead_offers}
                    lead_id={lead_id} updateMode={updateMode} />
                </Grid>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </DialogContent>
          {Number(access_rights.leads) === 2 ?
            <DialogActions style={{ justifyContent: 'center' }}>
              <Button variant="outlined" className="m-10" onClick={this.addLeadPlanOfferDialog} color="primary">
                Speichern
                            </Button>
              {updateMode &&
                <Button variant="outlined" className="m-10" onClick={this.launchDeleteLeadDialog} color="secondary">
                  Löschen
                            </Button>}
              <Button variant="outlined" className="m-10" onClick={this.abortLeadPlanOfferDialog} color="secondary">
                Abbrechen
                            </Button>
            </DialogActions> :
            <DialogActions style={{ justifyContent: 'center' }}>
              <Button variant="outlined" className="m-10" onClick={this.abortLeadPlanOfferDialog} color="secondary">
                Abbrechen
                            </Button>
            </DialogActions>}
        </Dialog>

        <Dialog open={LeadPlanOfferDeleteDialogOpen}>
          <DialogTitle>Akquise Löschen</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Sind Sie sicher?
                        </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleRemoveRow} variant="outlined" size="small" color="primary"
              autoFocus>
              Bestätigen
                        </Button>
            <Button onClick={this.closeDeleteLeadPlanOfferDialog} variant="outlined" color="secondary"
              size='small'>
              Abbrechen
                        </Button>
          </DialogActions>
        </Dialog>

        {total_percentages && total_percentages !== 100 && <Dialog open={LeadPlanOfferPercentagesDialogOpen}>
          <DialogTitle>Bestätigung</DialogTitle>
          <DialogContent>
            <DialogContentText className={'lead_percentages_warning'}>
              Die Summe der Lead-Prozentsätze ergeben nicht 100%. Trotzdem speichern?
                        </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.saveLeadPlanOfferPercentagesDialog} variant="outlined" size="small"
              color="primary"
              autoFocus>
              Ja
                        </Button>
            <Button onClick={this.closeLeadPlanOfferPercentagesDialog} variant="outlined" color="secondary"
              size='small'>
              Zurück
                        </Button>
          </DialogActions>
        </Dialog>}

        <Dialog open={LeadPlanOfferShouldCreateLeadPlanDialogOpen}>
          <DialogTitle>Bestätigung</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Sie müssen mindestens einen Lead-Plan erstellen, um die Erstellung dieses Leads
              abzuschließen
                        </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeLeadPlanOfferShouldCreateLeadPlanDialog} variant="outlined"
              color="secondary" size='small'>
              OK
                        </Button>
          </DialogActions>
        </Dialog>
        {createExcel && <ExcelData leads_list={this.props.leads_list} year={this.props.year} />}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ leads, branches, classifications, theme }) => {
  return {
    isloading: leads.loading,
    projects_list: leads.projects_list,
    users_list: leads.users_list,
    branches_list: branches.branches_list,
    classifications_list: classifications.classifications_list,
    themes_list: theme.themes_list,
    lead_plan_offer: leads.lead_plan_offer,
    error_validation: leads.error_message,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetProjectsData: () => dispatch(GetProjectsData()),
    GetUsersData: () => dispatch(GetUsersData()),
    GetBranches: () => dispatch(GetBranches()),
    GetClassifications: () => dispatch(GetClassifications()),
    GetThemes: () => dispatch(GetThemes()),
    CreateLeadPlanOffer: (leadProjectNumber, leadCustomerName, leadProjectName,
      leadBranchNumber, leadThemeNumber, leadClassificationNumber,
      leadComment, leadPartnerNumberOne, leadPercentNumberOne,
      leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
      leadPercentNumberThree, lead_plans, lead_offers, year, branch_id, classification_id, theme_id, group_id) =>
      dispatch(CreateLeadPlanOffer(leadProjectNumber, leadCustomerName, leadProjectName,
        leadBranchNumber, leadThemeNumber, leadClassificationNumber,
        leadComment, leadPartnerNumberOne, leadPercentNumberOne,
        leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
        leadPercentNumberThree, lead_plans, lead_offers, year, branch_id, classification_id, theme_id, group_id)),
    UpdateLeadPlanOffer: (lead_id, leadProjectNumber, leadCustomerName, leadProjectName,
      leadBranchNumber, leadThemeNumber, leadClassificationNumber,
      leadComment, leadPartnerNumberOne, leadPercentNumberOne,
      leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
      leadPercentNumberThree, year, branch_id, classification_id, theme_id, group_id) =>
      dispatch(UpdateLeadPlanOffer(lead_id, leadProjectNumber, leadCustomerName, leadProjectName,
        leadBranchNumber, leadThemeNumber, leadClassificationNumber,
        leadComment, leadPartnerNumberOne, leadPercentNumberOne,
        leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
        leadPercentNumberThree, year, branch_id, classification_id, theme_id, group_id)),
    DeleteLeadPlanOffer: (lead_id, year, branch_id, classification_id, theme_id, group_id) => dispatch(DeleteLeadPlanOffer(lead_id, year, branch_id, classification_id, theme_id, group_id)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadsSearchResults);